import React from "react";
import List from "@mui/material/List";
import Typography from "@mui/material/Typography";
import FileListItem from "../file-list-item";

const FileColumn = ({ column }) => (
    <div
      style={{
        border: "1px solid lightgrey",
        borderRadius: "5px",
        marginRight: "10px",
        padding: 5,
        width: "60%",
        minHeight: 0,
        overflow: "hidden"
      }}>
      <div style={{ overflowY: "auto", overflowX: "hidden", padding: 15, height: "100%" }}>
        <Typography fontSize="19px!important" variant="h5">
          {column.name}
        </Typography>
        <List>
          {column.list.map((itemObject, index) => (
            <FileListItem key={itemObject.columnName} index={index} itemObject={itemObject} />
          ))}
        </List>
      </div>
    </div>
  );

export default FileColumn;
